import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=13fa38a5&scoped=true&"
import script from "./ChangePhone.vue?vue&type=script&lang=js&"
export * from "./ChangePhone.vue?vue&type=script&lang=js&"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=13fa38a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa38a5",
  null
  
)

export default component.exports